import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaShip } from "react-icons/fa";
import "./About.css";
import bgImage from "./freight.jpeg"; // replace with port/ship image later

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section
      className="about-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay"></div>

      <div className="about-content" data-aos="fade-up">

        <FaShip className="about-icon" />

        <h1>
          <span className="about-yellow">Zuluwhiskey</span>{" "}
          <span className="about-white">Shipping Company</span>
        </h1>

        <p>
          Zuluwhiskey Shipping Company is a trusted logistics partner specializing in
          international shipping, cargo transportation, and warehousing solutions.
          We deliver goods safely and efficiently across borders, handling everything
          from small packages to heavy industrial materials.
        </p>

        <p>
          With a strong commitment to reliability, speed, and customer satisfaction,
          we ensure that every shipment reaches its destination securely and on time.
          Whether it’s global freight, construction materials, or doorstep delivery,
          we are your dependable logistics solution.
        </p>

        <button className="about-btn">Get Started</button>

      </div>
    </section>
  );
};

export default About;